import { buildChildURL } from '@centric-os/helpers';
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../../enums';

const Component = () =>
  import('../../../../../../audit-log/src/components/activity-log/ActivityLog.vue');

export default {
  path: buildChildURL(SitesRoutePathNames.ACTIVITY_LOG),
  name: SitesRouteNames.SITE_ACTIVITY_LOG,
  component: Component,
  props: (route: RouteLocationNormalized) => ({
    entityRefs: [{ type: 'group', id: route.params.siteId as string }],
  }),
} as RouteRecordRaw;
